export class OnboardRdsCdcResponse {
    'privateLinkInstructions';
    'sqlInstructions';
    'rdsSecurityGroups';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "privateLinkInstructions",
            "baseName": "privateLinkInstructions",
            "type": "{ [key: string]: PrivateLinkFormatInstructions; }",
            "format": ""
        },
        {
            "name": "sqlInstructions",
            "baseName": "sqlInstructions",
            "type": "SqlInstructions",
            "format": ""
        },
        {
            "name": "rdsSecurityGroups",
            "baseName": "rdsSecurityGroups",
            "type": "Array<RdsSecurityGroup>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return OnboardRdsCdcResponse.attributeTypeMap;
    }
    constructor() {
    }
}
